import React from "react";

import LojaModel from "./model/LojaModel";
import { FormControl } from "@material-ui/core";
import ObaTextField from "./components/ObaTextField";
import NavegadorUtil from "./util/NavegadorUtil";
import NavegadorAcaoEnum from "./util/NavegadorAcaoEnum";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import Rodape from "./components/Rodape";
import ProxyMensagemDAO from "./dataAccess/Proxy/ProxyMensagemDAO";
import AppState from "./model/AppState";
import Carregando from "./components/Carregando";
import { RouteComponentProps } from "react-router-dom";
import UsuarioModel from "./model/UsuarioModel";
import ObaUsuarioCadastroModel from "./model/ObaUsuarioCadastroModel";
import ObaUsuarioDAO from "./dataAccess/Oba/ObaUsuarioDAO";

interface IAjudaContatoProps extends RouteComponentProps {}

type AjudaContatoState = {
  loja: string;
  assunto: string;
  mensagem: string;
  enviarMensagem: boolean;
  enviado: boolean;
  carregando: boolean;
  concluido: boolean;
  nome: string;
  email: string;
};

class AjudaContato extends React.Component<
  IAjudaContatoProps,
  AjudaContatoState
> {
  constructor(props: IAjudaContatoProps) {
    super(props);

    this.enviarMensagem = this.enviarMensagem.bind(this);
    this.setAssunto = this.setAssunto.bind(this);
    this.setMensagem = this.setMensagem.bind(this);
    this.exibirFormMensagem = this.exibirFormMensagem.bind(this);

    this.state = {
      mensagem: "",
      assunto: "",
      loja: "",
      enviarMensagem: false,
      enviado: false,
      carregando: false,
      concluido: false,
      nome: "",
      email: "",
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Ajuda");

    const logado: UsuarioModel | null = AppState.getUsuarioLogado();

    if (logado) {
      this.setState({ carregando: true });
      ObaUsuarioDAO.getInstance()
        .getUsuario(logado.email)
        .then((u: ObaUsuarioCadastroModel) => {
          this.setState({
            nome: u.Nome,
            email: logado.email,
            carregando: false,
          });
        })
        .catch((e: any) => {
          this.setState({ carregando: false, concluido: true });
        });
    }
  }

  enviarMensagem(): void {
    const { nome, email, assunto, mensagem } = this.state;
    if (
      (nome && email && assunto && mensagem && nome.length === 0) ||
      assunto.length === 0 ||
      assunto.length === 0 ||
      mensagem.length === 0
    ) {
      NavegadorUtil.alerta(
        this,
        "Favor preencher os campos nome, email, assunto e mensagem.",
        "alerta-msg-ajuda",
        NavegadorAcaoEnum.NAV_UTIL_ALERTA_MENSAGEM_NAO_PREENCHIDO,
        ""
      );
    } else {
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      if (loja) {
        this.setState({ carregando: true });
        ProxyMensagemDAO.getInstance()
          .sendMensagem(
            loja,
            assunto,
            `Nome: ${nome}
            Email: ${email}
            Mensagem: ${mensagem}`
          )
          .then((e) => {
            this.setState({ carregando: false, concluido: true });
            NavegadorUtil.alerta(this, e.data.message);
          })
          .catch((e) => {
            this.setState({ carregando: false, concluido: true });
            NavegadorUtil.alerta(this, e.data.message);
          });
      }
    }
  }

  exibirFormMensagem(): void {
    this.setState({
      enviarMensagem: true,
    });
  }

  setNome(nome: string): void {
    this.setState({
      nome,
    });
  }

  setEmail(email: string): void {
    this.setState({
      email,
    });
  }

  setAssunto(assunto: string): void {
    this.setState({
      assunto,
    });
  }

  setMensagem(mensagem: string): void {
    this.setState({
      mensagem,
    });
  }

  render(): any {
    const { enviarMensagem, nome, email, enviado, carregando, concluido } = this.state;

    const fieldWidth: number = 300;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 30,
    };

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo="Fale com a gente"></BotaoVoltar>
        </div>
        {!enviado && (
          <>
            {!enviarMensagem && (
              <div className="ouvidoria">
                <p>
                  Ligue para a nossa ouvidoria
                  <br />
                  <strong>0800 707 0070</strong>
                </p>
                <button onClick={this.exibirFormMensagem}>
                  Ou envie uma mensagem
                </button>
              </div>
            )}
            {enviarMensagem && (
              <div className="assuntoMensagem">
                <FormControl variant="outlined" style={objStyle}>
                  <ObaTextField
                    onChange={(e) => this.setNome(e.target.value as string)}
                    style={{ width: fieldWidth }}
                    inputProps={{
                      name: "nome",
                      id: "nome",
                    }}
                    variant="outlined"
                    label="Nome"
                    value={nome}
                  />
                </FormControl>
                <FormControl variant="outlined" style={objStyle}>
                  <ObaTextField
                    onChange={(e) => this.setEmail(e.target.value as string)}
                    style={{ width: fieldWidth }}
                    inputProps={{
                      name: "email",
                      id: "email",
                    }}
                    variant="outlined"
                    label="E-mail"
                    value={email}
                  />
                </FormControl>
                <FormControl variant="outlined" style={objStyle}>
                  <ObaTextField
                    onChange={(e) => this.setAssunto(e.target.value as string)}
                    style={{ width: fieldWidth }}
                    inputProps={{
                      name: "assunto",
                      id: "assunto",
                    }}
                    variant="outlined"
                    label="Assunto"
                  />
                </FormControl>
                <FormControl variant="outlined" style={objStyle}>
                  <ObaTextField
                    multiline
                    rows="4"
                    onChange={(e) => this.setMensagem(e.target.value as string)}
                    style={{ width: fieldWidth }}
                    inputProps={{
                      name: "mensagem",
                      id: "mensagem",
                    }}
                    variant="outlined"
                    label="Mensagem"
                  />
                </FormControl>
                <button onClick={this.enviarMensagem}>Enviar mensagem</button>
              </div>
            )}
          </>
        )}
        <Carregando exibir={carregando} concluido={concluido}></Carregando>
        <Rodape parent={this} ativo="Menu"></Rodape>
      </section>
    );
  }
}

export default AjudaContato;
